import Vue from 'vue' // vue
import App from './App.vue' // vue主页面
import VueRouter from 'vue-router' // vue路由管理
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./style/base.css"
import './promission'//这里进行路由后台获取的模拟
import './icons'
import commonClass from '@/config/index' // 引入
import '../theme/index.css'
import store from './store'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'G4qCk0dybn7MYp4njqCbP5DfCRhSFPPZ'
  })
Vue.use(ElementUI);
Vue.use(commonClass) // 添加
Vue.config.productionTip = false
Vue.use(VueRouter) // vue路由


new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})